export default {
	SidebarOpenedKey: 'sidebarOpened',
	LangKey: 'lang',
	ComponentSizeKey: 'componentSize',
	TokenKey: 'token',
	ThemeKey: 'theme'
}
